import { useTrads } from "../../contexts/trads/useTrads";

function Pager({curpage,totalpages,setter}:{curpage:number,totalpages:number,setter:(e:number)=>void}){
    const loopPages=function(from:number,to:number){
        const content=[];
        for(let page=from;page<to;page++){
            content.push(
                <li key={page} className={curpage==page?"page-item active":"page-item"}>
                    <a onClick={()=>{setter(page)}} className="page-link" href="#">{page}</a>
                </li>
            )
        }
        return content;
    }
    const {translate}=useTrads();
    return (
        <nav aria-label={translate('pager_title')}>
            <ul className="pagination">
                <li className={curpage==0?"page-item disabled":'page-item'} >
                <a onClick={()=>{setter(curpage-1)}} className="page-link" href="#" aria-label={translate('pager_prev')}>
                    <span aria-hidden="true">&laquo;</span>
                </a>
                </li>
                {loopPages(0,totalpages)}
                <li className={totalpages <= curpage+1 ?"page-item disabled":'page-item'}>
                <a onClick={()=>{setter(curpage+1)}} className="page-link" href="#" aria-label={translate('pager_next')}>
                    <span aria-hidden="true">&raquo;</span>
                </a>
                </li>
            </ul>
        </nav>
    )
}
export default Pager;